<template>
	<div class="role_permissions_page">
		<div class="table_content">
			<a-button type="primary" class="new_button" @click="showform(null)">+ 新增</a-button>
			<a-table class="table_data" :columns="columns" :dataSource="roleData.dataList" :pagination="false"
				:customRow="rowClick">
				<span slot="action" slot-scope="text">
					<a-tooltip>
						<a-button type="link" @click="editPower(text)">编辑角色</a-button>
					</a-tooltip>
					<a-tooltip>
						<template slot="title">删除角色之后不可恢复，请谨慎操作</template>
						<a-button type="link" style="color: red" @click="delData(text.roleId)">删除角色</a-button>
					</a-tooltip>
				</span>
			</a-table>
		</div>
		<a-modal :title="formData.roleId ? '编辑角色' : '新增角色'" v-model="newVisible" width="80%" @ok="postData" okText="确认"
			cancelText="取消">
			<a-row :gutter="40">
				<a-col :span="12"><a-form-item label="角色名称" :colon="false">
						<a-input v-model="formData.roleName" />
					</a-form-item>
				</a-col>
				<a-col :span="12"><a-form-item label="角色描述" :colon="false">
						<a-input v-model="formData.roleDesc" /> </a-form-item></a-col>
			</a-row>

			<a-form-item label="关联权限" :colon="false">
				<div class="role_content_box">
					<div class="power_box">
						<div class="power_row" v-for="(menu, index) in powerList" :key="index">
							<div class="power_left" style="width: 143px">
								<a-checkbox :indeterminate="isIndeterminate(index)" :checked="menu.checked"
									:disabled="!editRolePower"
									@change="menuChange(index, 'menu')">{{ menu.label }}</a-checkbox>
							</div>
							<div class="power_right">
								<div class="power_row">
									<div class="power_left" v-for="(item, indexItem) in menu.children" :key="indexItem">

										<div><a-checkbox :checked="item.checked" :disabled="!editRolePower"
											@change="menuChange(index, 'item', indexItem)">{{ item.label }}</a-checkbox></div>
										<div style="display: flex;flex-direction: row;">
											<div class=""  v-for="(val, valIndex) in item.children" :key="valIndex">
												<a-checkbox :disabled="!editRolePower"	:checked="val.checked"	@change="menuChange(index, 'val', indexItem, valIndex)">{{ val.label }}</a-checkbox>
											</div>
										</div>									
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</a-form-item>
		</a-modal>
	</div>
</template>

<script>
	import {
		menuList
	} from "@/config/routerConfig";
	const powerData = menuList.map((item) => {
		let obj = {};
		obj.label = item.title;
		obj.value = item.name;
		obj.checked = false;
		if (item.children) {
			obj.checkedList = [];
			obj.children = item.children.map((e) => {
				let element = {};
				element.label = e.title;
				element.value = e.name;
				element.checked = false;
				if (e.children) {
					element.children = e.children.map((sonItem) => {
						let sonChildren = {};
						sonChildren.label = sonItem.title;
						sonChildren.value = sonItem.name;
						sonChildren.checked = false;
						return sonChildren;
					});
				}
				return element;
			});
		}
		return obj;
	});

	// 给工厂/品牌管理页面追加按钮级权限（不入 routerConfig，避免影响侧边栏）
	const factoryManage = powerData.find(m => m.value === 'FACTORYMODULE')
		?.children?.find(c => c.value === 'FACTORYMANAGE');
	if (factoryManage) {
		factoryManage.children = [
			{ label: '新建', value: 'FACTORY_ADD', checked: false },
			{ label: '编辑', value: 'FACTORY_EDIT', checked: false },
			{ label: '删除', value: 'FACTORY_DEL', checked: false },
			{ label: '导入', value: 'FACTORY_IMPORT', checked: false },
		];
	}

	const brandManage = powerData.find(m => m.value === 'BRANDMODULE')
		?.children?.find(c => c.value === 'BRANDMANAGE');
	if (brandManage) {
		brandManage.children = [
			{ label: '新建', value: 'BRAND_ADD', checked: false },
			{ label: '编辑', value: 'BRAND_EDIT', checked: false },
			{ label: '删除', value: 'BRAND_DEL', checked: false },
			{ label: '导入', value: 'BRAND_IMPORT', checked: false },
		];
	}

	const executionStandard = powerData.find(m => m.value === 'LAWSMODULE')
		?.children?.find(c => c.value === 'EXECUTIONSTANDARD');
	if (executionStandard) {
		executionStandard.children = [
			{ label: '话术编辑', value: 'EXECUTIONSTANDARD_SCRIPT', checked: false },
			{ label: '导入', value: 'EXECUTIONSTANDARD_IMPORT', checked: false },
			{ label: '新建', value: 'EXECUTIONSTANDARD_ADD', checked: false },
			{ label: '编辑', value: 'EXECUTIONSTANDARD_EDIT', checked: false },
			{ label: '删除', value: 'EXECUTIONSTANDARD_DEL', checked: false },
		];
	}

	const lawsRegulations = powerData.find(m => m.value === 'LAWSMODULE')
		?.children?.find(c => c.value === 'LAWSREGULATIONS');
	if (lawsRegulations) {
		lawsRegulations.children = [
			{ label: '新建', value: 'LAWSREGULATIONS_ADD', checked: false },
			{ label: '编辑', value: 'LAWSREGULATIONS_EDIT', checked: false },
			{ label: '删除', value: 'LAWSREGULATIONS_DEL', checked: false },
		];
	}

	const triggerCase = powerData.find(m => m.value === 'LAWSMODULE')
		?.children?.find(c => c.value === 'TRIGGERCASE');
	if (triggerCase) {
		triggerCase.children = [
			{ label: '话术编辑', value: 'TRIGGERCASE_SCRIPT', checked: false },
			{ label: '导入', value: 'TRIGGERCASE_IMPORT', checked: false },
			{ label: '新建', value: 'TRIGGERCASE_ADD', checked: false },
			{ label: '编辑', value: 'TRIGGERCASE_EDIT', checked: false },
			{ label: '删除', value: 'TRIGGERCASE_DEL', checked: false },
		];
	}

	const complaintGuide = powerData.find(m => m.value === 'LAWSMODULE')
		?.children?.find(c => c.value === 'COMPLAINTGUIDE');
	if (complaintGuide) {
		complaintGuide.children = [
			{ label: '话术编辑', value: 'COMPLAINTGUIDE_SCRIPT', checked: false },
			{ label: '新建', value: 'COMPLAINTGUIDE_ADD', checked: false },
			{ label: '编辑', value: 'COMPLAINTGUIDE_EDIT', checked: false },
			{ label: '删除', value: 'COMPLAINTGUIDE_DEL', checked: false },
		];
	}

	const labelSettings = powerData.find(m => m.value === 'LABELMODULE')
		?.children?.find(c => c.value === 'LABELSETTINGS');
	if (labelSettings) {
		labelSettings.children = [
			{ label: '编辑', value: 'LABELSETTINGS_EDIT', checked: false },
		];
	}

	const fctoryBand = powerData.find(m => m.value === 'LABELMODULE')
		?.children?.find(c => c.value === 'FCTORY_BAND_SPPLIERMANAGE');
	if (fctoryBand) {
		fctoryBand.children = [
			{ label: '新建', value: 'FCTORY_BAND_ADD', checked: false },
			{ label: '编辑', value: 'FCTORY_BAND_EDIT', checked: false },
			{ label: '删除', value: 'FCTORY_BAND_DEL', checked: false },
		];
	}

	console.log(powerData, "powerData");
	import {
		roleListApi,
		roleEditApi,
		roleDeleteApi
	} from "../../api/index";
	export default {
		name: "roleList",
		data() {
			return {
				columns: [{
						title: "角色",
						dataIndex: "roleName",
						key: "roleName",
						width: 300,
					},
					{
						title: "角色描述",
						key: "roleDesc",
						dataIndex: "roleDesc",
					},
					{
						title: "操作",
						align: "center",
						width: 300,
						scopedSlots: {
							customRender: "action"
						},
					},
				],
				roleData: {
					totalNum: 0,
					dataList: [],
				},
				powerList: JSON.parse(JSON.stringify(powerData)),
				delvisible: false,
				newVisible: false,
				rowClick: (record) => ({
					on: {
						click: () => {
							if (!this.editRolePower) {
								this.roleData.roleId = record.roleId;
								this.roleData.roleName = record.roleName;
								if (record.resources) {
									this.powerList = this.powerStrToPowerArray(record.resources);
								} else {
									this.powerList = JSON.parse(JSON.stringify(powerData));
								}
							}
						},
					},
				}),
				formData: {
					roleId: 0,
					roleName: "",
					roleDesc: "",
				},
				powerData: {
					roleId: 0,
					roleName: "",
					rolePermissions: "",
				},
				editFlag: false,
				editRolePower: false,
			};
		},
		created() {
			this.getData();
		},
		computed: {},
		methods: {
			showform(obj) {
				this.editRolePower = true;
				this.newVisible = true;
				this.powerList = JSON.parse(JSON.stringify(powerData));
				if (obj) {
					this.formData.roleId = obj.roleId;
					this.formData.roleName = obj.roleName;
				} else {
					this.formData.roleId = 0;
					this.formData.roleName = "";
				}
			},
			editPower(record) {
				this.editRolePower = true;
				this.powerData.roleId = record.roleId;
				this.powerData.roleName = record.roleName;				
				if (record.resources) {
					// const result = 'PRODUCT_MSG;PRODUCT_ONE;PRODUCT_TWO;PRODUCT_THREE;PRODUCT_FOUR;PRODUCT_FIVE'
					this.powerList = this.powerStrToPowerArray(record.resources);
				} else {
					this.powerList = JSON.parse(JSON.stringify(powerData));
				}
				this.newVisible = true;
				if (record) {
					this.formData.roleId = record.roleId;
					this.formData.roleName = record.roleName;
					this.formData.roleDesc= record.roleDesc;
				} else {
					this.formData.roleId = 0;
					this.formData.roleName = "";
					this.formData.roleDesc= record.roleDesc;
				}
			},
			cancelEdit() {
				this.editRolePower = false;
			},
			savePower() {
				this.powerData.rolePermissions = this.changePower(this.powerList);
				console.log(this.powerData.rolePermissions);
				this.putData();
			},
			//  判断全选
			isIndeterminate(index) {
				if (this.powerList[index].children) {
					return (
						this.powerList[index].checkedList.length > 0 &&
						this.powerList[index].checkedList.length <
						this.powerList[index].children.length
					);
				} else {
					return false;
				}
			},
			//  权限数组转字符串
			changePower(array) {
				let result = [];
				array.forEach((item) => {
					if (item.checked) {
						result.push(item.value);
						if (item.children) {
							item.children.forEach((itemChild) => {
								if (itemChild.checked) {
									result.push(itemChild.value);
									if (itemChild.children) {
										itemChild.children.forEach((itemChildS) => {
											if (itemChildS.checked) {
												result.push(itemChildS.value);
											}
										});
									}
								}
							});
						}
					}
				});
				return result.join(";");
			},
			// 权限字符串转为数组
			powerStrToPowerArray(resources) {
				const resourcesArray = resources.split(";");
				const array = JSON.parse(JSON.stringify(powerData));
				array.forEach((menu) => {
					console.log("menu", menu);
					if (resourcesArray && resourcesArray.indexOf(menu.value) > -1) {
						menu.checked = true;
						if (menu.children) {
							menu.children.forEach((item) => {
								if (resourcesArray.indexOf(item.value) > -1) {
									item.checked = true;
									if (item.children) {
										item.children.forEach((itemChild) => {
											if (resourcesArray.indexOf(itemChild.value) > -1) {
												itemChild.checked = true;
											}
										});
									}
								}
							});
						}
					}
				});
				return array;
			},
			getData() {
				roleListApi()
					.then((res) => {
						if (res.resultStatus) {
							this.roleData = {
								...res.resultData,
								dataList: res.resultData.records.map((f, i) => {
									f.key = f.roleId;
									f.visible = false;
									return f;
								}),
							};
						} else {
							this.$message.warn(res.errorMessage);
							this.roleData = {
								totalNum: 0,
								dataList: [],
							};
						}
					})
					.catch((err) => {
						console.error(err);
						this.roleData = {
							totalNum: 0,
							dataList: [],
						};
					});
			},
			postData() {
				this.powerData.rolePermissions = this.changePower(this.powerList);
				console.log(this.powerData.rolePermissions);

				roleEditApi({
						roleId: this.formData.roleId,
						roleName: this.formData.roleName,
						resources: this.powerData.rolePermissions,
						roleDesc: this.formData.roleDesc,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.formData.roleId ? "更改成功" : "新增成功"
							);
							this.newVisible = false;
							this.getData();
						} else {
							this.$message.warn(res.errorMessage);
						}
					})
					.catch((err) => {
						console.error(err);
					});
			},
			putData() {
				this.$store
					.dispatch("putRolePower", {
						id: this.powerData.roleId,
						params: {
							resources: this.powerData.rolePermissions
						},
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("设置成功");
							this.editRolePower = false;
							this.getData();
						} else {
							this.$message.warn(res.errorMessage);
						}
					})
					.catch((err) => {
						console.error(err);
					});
			},
			delData(id) {
				roleDeleteApi({
						roleId: id,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.delvisible = false;
							this.getData();
						} else {
							this.$message.warn(res.errorMessage);
						}
					})
					.catch((err) => {
						console.error(err);
					});
			},
			// 修改权限
			menuChange(index, flag, indexItem = 0, indexChild = 0) {
				console.log(this.powerList, "powerList----------------");
				if (flag == "menu") {
					this.powerList[index].checked = !this.powerList[index].checked;
					if (this.powerList[index].children) {
						this.powerList[index].children.forEach((item) => {
							item.checked = this.powerList[index].checked;
							if (item.children) {
								item.children.forEach((itemChild) => {
									itemChild.checked = this.powerList[index].checked;
								});
							}
						});
					}
				} else if (flag == "item") {
					this.powerList[index].children[indexItem].checked = !this.powerList[index].children[indexItem].checked;
					if (this.powerList[index].children[indexItem].checked) {
						this.powerList[index].checked = true;
					}
					if (this.powerList[index].children[indexItem].children) {
						this.powerList[index].children[indexItem].children.forEach((item) => {
							item.checked = this.powerList[index].children[indexItem].checked;
						});
					}
				} else {
					this.powerList[index].children[indexItem].children[indexChild].checked = !this.powerList[index]
						.children[indexItem].children[indexChild]
						.checked;
					if (
						this.powerList[index].children[indexItem].children[indexChild].checked
					) {
						this.powerList[index].children[indexItem].checked = true;
						this.powerList[index].checked = true;
					}
				}
			},
		},
		activated() {
			this.getData();
		},
	};
</script>

<style lang="less">
	.role_permissions_page {
		width: 100%;
		height: 100%;
		padding: 20px;
		background: #ffffff;

		.table_content {
			.new_button {
				height: 32px;
				width: 80px;
			}

			.table_data {
				margin: 20px 0 40px;

				button.delete {
					padding: 0 8px;
				}
			}
		}

		.role_box {
			background: #ffffff;
			border-radius: 5px;

			header {
				padding: 26px 20px;
				box-sizing: border-box;
				position: relative;
				color: #333333;
				font-size: 22px;
				line-height: 30px;

				&::before {
					content: "";
					width: 3px;
					height: 30px;
					background: #6ebf89;
					position: absolute;
					left: 0;
					top: 26px;
				}

				.tip_name {
					padding-left: 16px;
					color: #6ebf89;
					font-size: 18px;
				}

				.header_btn {
					float: right;

					.header_button {
						border-color: #6ebf89;
						color: #6ebf89;
						margin-right: 20px;
					}
				}
			}
		}
	}

	.role_content_box {
		width: 100%;
		height: auto;
		padding: 0 40px 40px;
		display: flex;

		.power_box {
			width: 100%;
			height: auto;
			border: 1px solid #eeeeee;
			border-bottom: 0;

			.power_row {
				display: flex;
				flex-wrap: wrap;
				background: #ffffff;
				border-bottom: 1px solid #eeeeee;
			}

			.power_left {
				// width: 200px;
				min-height: 41px;
				border-right: 1px solid #eeeeee;
				padding: 0px 20px;
				box-sizing: border-box;
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}

			.power_left:last-child {
				border-right: 0px solid #eeeeee;
			}

			.power_right {
				flex: 1;

				.ant-checkbox-group {
					width: 100%;
					height: auto;
				}

				.ant-checkbox-group-item {
					display: block;
					padding: 10px 20px;
					box-sizing: border-box;
					border-bottom: 1px solid #eeeeee;

					&:last-child {
						border: 0;
					}
				}
			}

			.button_role {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 40px;
				line-height: 40px;
			}

			.ant-checkbox-indeterminate .ant-checkbox-inner::after {
				background-color: #6ebf89;
			}
		}
	}
</style>